import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs, ThemeProvider, createTheme } from "@mui/material";
import { grey } from "@mui/material/colors";

import ItemDashboard from "../../../components/LabelDashboard";
import ProvGraph from "./ProvGraph";
import ClientsOlt from "./ClientsOLT";

// Sinal/status vem do Redis live (coleta v3). SignalQualityChart (24h) e
// os componentes Optimized*/Hybrid foram REMOVIDOS: liam ONUSignalDaily /
// série densa, que não existem mais com report-by-exception.
import {
    RealTimeStatus,
    ProblematicONUs,
    SignalDistribution,
    DowntimeHistory
} from './ChartComponents';

import {
    DowntimeByCause,
    DowntimeTimeline,
    DowntimeByHour,
    TopProblematicONUs,
    IncidentSummary
} from './DowntimeAnalysisComponents';

import { useAuth } from "../../../components/AuthProvider";
import { useNavigate } from "react-router-dom";


// Linha responsiva: 1 coluna no mobile, 2 no desktop.
function Row({ children, mb = 0 }) {
    return (
        <Box display="flex" gap={2} flexWrap="wrap"
            sx={{ mb, '& > *': { flex: { xs: '1 1 100%', lg: '1 1 calc(50% - 8px)' } } }}>
            {children}
        </Box>
    );
}


export default function Dashboard() {
    const theme = createTheme({
        palette: { primary: { main: grey[900] }, secondary: { main: grey[900] } },
    });

    const auth = useAuth();
    const navigate = useNavigate();
    const [tab, setTab] = useState(0);

    useEffect(() => {
        if (!auth.hasPerm("dashboard.get_all")) {
            navigate("provisioning/add_onu");
        }
    }, []);

    if (!auth.hasPerm("dashboard.get_all")) {
        return null;
    }

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ p: { xs: 1, sm: 2 }, display: 'flex', flexDirection: 'column', gap: 2 }}>

                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        borderBottom: 1, borderColor: 'divider',
                        '& .MuiTab-root': {
                            fontFamily: 'Montserrat', fontWeight: 600,
                            textTransform: 'none', fontSize: { xs: '0.85rem', sm: '1rem' }
                        }
                    }}
                >
                    <Tab label="Visão Geral" />
                    <Tab label="Quedas & Incidentes" />
                    <Tab label="Crescimento" />
                </Tabs>

                {/* ── Aba 1: VISÃO GERAL (Redis live — estado agora) ── */}
                {tab === 0 && (
                    <Box display="flex" flexDirection="column" gap={3}>
                        <Box display="flex" gap={2} flexWrap="wrap"
                            sx={{ '& > *': {
                                flex: { xs: '1 1 calc(50% - 8px)', sm: '1 1 calc(25% - 12px)' },
                                minWidth: { xs: 160, sm: 200 } } }}>
                            <ItemDashboard endpoint="/provisioning/dashboard/count/olt" label="OLT" />
                            <ItemDashboard endpoint="/provisioning/dashboard/count/cto" label="CTO" />
                            <ItemDashboard endpoint="/provisioning/dashboard/count/onu" label="Clientes" />
                            <ItemDashboard endpoint="/provisioning/dashboard/count/provisioned_onu" label="Provisionados" />
                        </Box>
                        <RealTimeStatus />
                        <Row>
                            <SignalDistribution />
                            <ProblematicONUs />
                        </Row>
                    </Box>
                )}

                {/* ── Aba 2: QUEDAS & INCIDENTES (down_history) ── */}
                {tab === 1 && (
                    <Box display="flex" flexDirection="column" gap={3}>
                        <IncidentSummary />
                        <Row>
                            <DowntimeByCause />
                            <DowntimeByHour />
                        </Row>
                        <Row>
                            <DowntimeHistory />
                            <TopProblematicONUs />
                        </Row>
                        <DowntimeTimeline />
                    </Box>
                )}

                {/* ── Aba 3: CRESCIMENTO (prov_daily / cadastro) ── */}
                {tab === 2 && (
                    <Box display="flex" flexDirection="column" gap={3}>
                        <Row>
                            <ProvGraph />
                            <ClientsOlt />
                        </Row>
                    </Box>
                )}

            </Box>
        </ThemeProvider>
    );
}
